module.exports = __webpack_public_path__ + "media/images/e-kvitok/train_active-17e7c2ed6c6f5ff1e93bec14668e8c7d.svg";